export default "__VITE_ASSET__8WXxhZvs__"